'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _workstation = require('redux/modules/workstation');

var workstationAction = _interopRequireWildcard(_workstation);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { push } from 'react-router-redux';

var Workstation = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var params = _ref.params;

    if (!workstationAction.isLoaded(getState())) {
      return dispatch(workstationAction.load(params.workstationId));
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.workstation.data
  };
}, (0, _extends3.default)({}, workstationAction)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Workstation, _Component);

  function Workstation() {
    (0, _classCallCheck3.default)(this, Workstation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Workstation).call(this));

    _this.state = {
      workstationImg: [{
        img: 'http://tupian.goeasy.cn:9999/yipinwang/workstation/henan/moban_bg16.jpg'
      }, {
        img: 'http://tupian.goeasy.cn:9999/yipinwang/workstation/henan/moban_bg17.jpg'
      }]
    };
    return _this;
  }

  (0, _createClass3.default)(Workstation, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Workstation.scss');
      var _props = this.props;
      var params = _props.params;
      var data = _props.data;
      // console.log(params);

      var contentLeftDiv = _react2.default.createElement(
        'div',
        { className: styles.contentLeft },
        _react2.default.createElement('div', { className: styles.img_box }),
        _react2.default.createElement(
          'div',
          { className: styles.img_txt },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/workstationshoplist/' + params.workstationId,
              className: styles.ahref + ' ' + styles.Scale },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/workstation/henan/moban_bg20.png', alt: '' })
          )
        )
      );
      if (data) {
        // console.log(data);
        var workstationMainPage = data.workstationMainPage;
        var workstationMainPageError = data.workstationMainPageError;

        if (workstationMainPageError) {
          contentLeftDiv = _react2.default.createElement(
            'div',
            { className: styles.contentLeft },
            workstationMainPageError
          );
        } else {
          if (workstationMainPage) {
            (function () {
              var imageLeftArray = [];
              if (typeof workstationMainPage[0].img === 'string' && workstationMainPage[0].img !== '') {
                var ImgArray = workstationMainPage[0].img.split(',');
                ImgArray.forEach(function (item, index) {
                  if (index < 3) {
                    imageLeftArray.push({ img: item });
                  }
                });
              }
              contentLeftDiv = _react2.default.createElement(
                'div',
                { className: styles.contentLeft },
                _react2.default.createElement(
                  'div',
                  { className: styles.img_box },
                  _react2.default.createElement('img', { src: workstationMainPage[0].logo, alt: '',
                    className: styles.logo_bg }),
                  _react2.default.createElement(_components.ImageChangeComponent, { data: imageLeftArray })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.img_txt },
                  _react2.default.createElement('img', { src: workstationMainPage[0].introImg, alt: '', className: styles.img_title }),
                  _react2.default.createElement(
                    'p',
                    { className: styles.img_txt_txt },
                    workstationMainPage[0].introduce
                  ),
                  _react2.default.createElement('div', { className: 'clear' }),
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/workstationshoplist/' + params.workstationId,
                      className: styles.ahref + ' ' + styles.Scale },
                    _react2.default.createElement('img', {
                      src: 'http://tupian.goeasy.cn:9999/yipinwang/workstation/henan/moban_bg20.png', alt: '' })
                  )
                )
              );
            })();
          }
        }
      }
      // id,name,introduce,img,introImg,logo,background
      return _react2.default.createElement(
        'div',
        { className: styles.cr_component,
          style: { backgroundImage: 'url(' + (data.workstationMainPage && data.workstationMainPage[0].background ? data.workstationMainPage[0].background : 'http://tupian.goeasy.cn:9999/yipinwang/header/bg_img1.jpg') + ')', backgroundSize: '100%' } },
        _react2.default.createElement(_components.NewHeader, { isNotBack: !!1, isLinkShow: !1, style: { position: 'relative' } }),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          contentLeftDiv,
          _react2.default.createElement(
            'div',
            { className: styles.contentRight },
            _react2.default.createElement('div', { className: styles.contentRightBlack }),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/workstationlist', className: styles.contentRightHome },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/header/icon-fanhui.png', alt: '' })
            )
          )
        )
      );
    }
  }]);
  return Workstation;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  location: _react.PropTypes.object,
  params: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = Workstation;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Workstation/Workstation.js
 ** module id = 1554
 ** module chunks = 0
 **/